module.exports = require("react-transition-group");


//////////////////
// WEBPACK FOOTER
// external "react-transition-group"
// module id = 19
// module chunks = 0